module.exports = __webpack_public_path__ + "fonts/Zen_Maru_Gothic-300-15.9fd42fe.woff2";